import { render } from "./EducationExperienceContainer.vue?vue&type=template&id=8cc5e822&scoped=true"
import script from "./EducationExperienceContainer.vue?vue&type=script&lang=js"
export * from "./EducationExperienceContainer.vue?vue&type=script&lang=js"

import "./EducationExperienceContainer.vue?vue&type=style&index=0&id=8cc5e822&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc5e822"]])

export default __exports__